import React from 'react';
import { FormattedMessage, intlShape } from 'react-intl';
import autobind from 'autobind-decorator';
import MessageDefinitions from '../i18n/MessageDefinitions';
import { textInput, checkboxInput } from '../../common/util/FormInput';
import { Form } from 'react-form-controlled';
import Validate from 'react-form-controlled-validate';
import FontAwesome from 'react-fontawesome';

const schema = {
  type: 'object',
  properties: {
    fromName: {
      type: 'string',
      minLength: 1
    },
    fromAddress: {
      type: 'string',
      format: 'email'
    },
    toName: {
      type: 'string',
      minLength: 1
    },
    toAddress: {
      type: 'string',
      format: 'email'
    },
    bccAddress1: {
      type: 'string',
      format: 'email'
    }
  },
  required: ['fromAddress', 'toAddress']
};

class EmailResultsForm extends React.Component {

  static contextTypes = {
    intl: intlShape
  };

  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      errors: [],
      visibleErrors: [],
      form: {
        copyMe: true,
        ...props.form
      }
    }
  }

  @autobind
  validateForm(state) {
    this.form.validate(state).then((formErrors = []) => {
      const errors = formErrors.map(error => {
        return {
          key: error.path,
          errors: [error.message]
        };
      });
      const visibleErrors = errors.filter(error => state.hasOwnProperty(error.key));
      this.setState({
        form: state,
        errors,
        visibleErrors
      });
    });
  }

  @autobind
  valueChanged(state) {
    this.validateForm(state);
  }

  @autobind
  formSubmitted(state) {
    this.setState({
      processing: true
    });
    const from = {
      email: state.fromAddress
    };
    if (state.fromName) {
      from.name = state.fromName;
    }
    const to = {
      email: state.toAddress
    };
    if (state.toName) {
      to.name = state.toName;
    }
    const bcc = [];
    if (this.props.form && this.props.form.bccAddress1) {
      bcc.push({ email: this.props.form.bccAddress1 });
    }
    const payload = {
      from,
      to,
      bcc,
      copyMe: !!state.copyMe
    };

    window.ignite.contactService.emailResults(payload).then(result => {
      if (result.status === 'success') {
        if (window.ignite.emailResultsSent) {
          window.ignite.emailResultsSent();
        }
      }
    });
  }

  componentDidMount() {
    this.valueChanged(this.state.form || {});
  }

  render() {

    const formatMessage = this.context.intl.formatMessage;

    const { processing, form, errors = [], visibleErrors = [] } = this.state;

    const buttonMessage =
      processing
        ? <FontAwesome name="refresh" spin/>
        : <FormattedMessage {...MessageDefinitions.submitEmail} />;

    const formValid = errors.length === 0;

    const fieldErrors = {};

    visibleErrors.forEach(error => {
      fieldErrors[error.key] = true;
    });

    const fromFields = [
      textInput({
        type: 'text',
        name: 'fromName',
        labelMessage: MessageDefinitions.fromName,
        errorMessage: MessageDefinitions.fromNameError,
        placeholderMessage: MessageDefinitions.fromNamePlaceholder,
        hasError: fieldErrors['fromName'],
        formatMessage
      }),
      textInput({
        type: 'email',
        name: 'fromAddress',
        labelMessage: MessageDefinitions.fromAddress,
        errorMessage: MessageDefinitions.fromAddressError,
        placeholderMessage: MessageDefinitions.fromAddressPlaceholder,
        hasError: fieldErrors['fromAddress'],
        formatMessage
      })
    ];

    const toFields = [
      textInput({
        type: 'text',
        name: 'toName',
        labelMessage: MessageDefinitions.toName,
        errorMessage: MessageDefinitions.toNameError,
        placeholderMessage: MessageDefinitions.toNamePlaceholder,
        hasError: fieldErrors['toName'],
        formatMessage
      }),
      textInput({
        type: 'email',
        name: 'toAddress',
        labelMessage: MessageDefinitions.toAddress,
        errorMessage: MessageDefinitions.toAddressError,
        placeholderMessage: MessageDefinitions.toAddressPlaceholder,
        hasError: fieldErrors['toAddress'],
        formatMessage
      }),
      checkboxInput({
        name: 'copyMe',
        labelMessage: MessageDefinitions.copyMe
      })
    ];

    return (
      <Validate schema={schema} ref={f => this.form = f}>
        <Form value={form}
              className="form-container"
              onChange={this.valueChanged}
              onSubmit={this.formSubmitted}>
          <div className="form-body">
            <div className="from-fields">
              <h3 className="from-header">From</h3>
              {fromFields}
            </div>
            <div className="to-fields">
              <h3 className="to-header">To</h3>
              {toFields}
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary save" disabled={!formValid || processing}>
              {buttonMessage}
            </button>
          </div>
        </Form>
      </Validate>
    );

  }

}

export default EmailResultsForm;



/** WEBPACK FOOTER **
 ** ./src/main/js/social/components/EmailResultsForm.js
 **/